/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const TextHitStyled = styled.p`
  color: #414141;
  font-size: 14px;
  margin: 0;
`;
